import React from 'react';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { CustomersListCard } from './CustomersListCard';

export const CustomersListPage = () => {
  return (
    <PageContainer>
      <CustomersListCard />
    </PageContainer>
  );
};
